import { useEffect, useState } from 'react'
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Grid2,
  Snackbar,
  Step,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material'
import { RegistCreditCard } from '../RegistCreditCard'
import { RequestConfirm } from '../EntryConfirm'
import { RequestForm } from '../EmtryForm'
import { isNil } from 'lodash/fp'
// import { createMemberId, getIsCreditRegistered, sendRequestData } from './functions';
import { createMemberId, sendRequestData } from './functions'
import log from 'loglevel'
import { isEmpty } from 'lodash'
import { CreditCheck, CreditCheckError, FormsProps } from '../../types'
import alertPropaties from './alert-propaties.json'
import { useAuth0, Auth0Context, User } from '@auth0/auth0-react'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ServerError } from '../ServerError'
import { domainName, httpRequest } from '../../functions/common'
import { Loading } from '../Loading'

log.setLevel(log.levels.DEBUG)

type FormProgressProps = {
  contentNameArray: Array<string>
  lastContent: JSX.Element
  buttonNames: {
    next: string
    back: string
    submit: string
    correct: string
  }
}

enum ActiveSteps {
  form = 0,
  credit = 1,
  confirm = 2
}

const getStepContent = (
  stepIndex: number,
  contentArray: Array<JSX.Element>
): JSX.Element | undefined => {
  return stepIndex >= contentArray.length ? undefined : contentArray[stepIndex]
}

export const FormProgress = (props: FormProgressProps) => {
  const { user, getAccessTokenSilently } = useAuth0(Auth0Context)

  const { contentNameArray, lastContent, buttonNames } = props
  const [activeStep, setActiveStep] = useState<number>(0)

  const [memberId, setMemberId] = useState<string>(createMemberId())
  const [lastName, setLastName] = useState<string>('')
  const [firstName, setFirstName] = useState<string>('')
  const [lastNameKana, setLastNameKana] = useState<string>('')
  const [firstNameKana, setFirstNameKana] = useState<string>('')
  const [postalCode, setPostalCode] = useState<string>('')
  const [pref, setPref] = useState<string>('')
  const [city, setCity] = useState<string>('')
  const [town, setTown] = useState<string>('')
  const [place, setPlace] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  // const [email, setEmail] = useState<string>(authMail as string)
  const [email, setEmail] = useState<string>('')
  const [barthYear, setBarthYear] = useState<string>('')
  const [barthMonth, setBarthMonth] = useState<string>('')
  const [gender, setGender] = useState<string>('')
  const [gas, setGas] = useState<string>('')
  const [kateneMailMagazine, setKateneMailMagazine] = useState<boolean>(false)
  const [tokutokuMailMagazine, setTokutokuMailMagazine] =
    useState<boolean>(false)
  const [customerNumber, setCustomerNumber] = useState<string>('')
  const [unknownCustomerNumber, setUnknownCustomerNumber] =
    useState<boolean>(false)
  const [payment, setPayment] = useState<string>('')
  const [paymentNumber, setPaymentNumber] = useState<string>('')
  const [contractorName, setContractorName] = useState<string>('')
  const [contractorNameKana, setContractorNameKana] = useState<string>('')
  const [contractorPostalCode, setContractorPostalCode] = useState<string>('')
  const [contractorPhone, setContractorPhone] = useState<string>('')
  const [agree, setAgree] = useState<boolean>(false)
  const [covenant, setCovenant] = useState<boolean>(false)
  const [kateneId, setKateneId] = useState<string>('')
  const [tcId, setTcId] = useState<string>('')

  const [couponCode, setCouponCode] = useState<string>('')

  const [alertStatus, setAlertStatus] = useState<
    'credit-bad-request' | 'credit-internal-error' | 'confirm' | undefined
  >(undefined)
  const [loading, setLoading] = useState<boolean>(true)
  const [hasError, setHasError] = useState<boolean>(false)
  const steps = contentNameArray
  const customerNumberIsUnknown = {
    lastName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    firstName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    lastNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    firstNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    postalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    pref: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    city: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    town: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    place: z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください')
      .or(z.string().length(0)),
    phone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    customerNumber: z.string(),
    payment: z.string().min(1, { message: '選択してください' }),
    paymentNumber: z
      .string()
      .min(4, { message: '選択してください' })
      .regex(/^[0-9]+$/, '半角数字で入力してください'),
    contractorName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    contractorNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー　 ]+$/, 'ひらがなで入力してください'),
    contractorPostalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    contractorPhone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    couponCode: z
      .string()
      .regex(/^[0-9,A-Z,a-z]+$/, '半角英数字で入力してください')
      .or(z.string().length(0)),
    aggree: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    }),
    covenant: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    })
  }
  const paymentIsUnknown = {
    // unknownCustomerNumber: z.literal(false),
    payment: z.string().min(1, { message: '選択してください' }),
    lastName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    firstName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    lastNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    firstNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    postalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    pref: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    city: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    town: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    place: z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください')
      .or(z.string().length(0)),
    phone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    paymentNumber: z.string().or(z.string().length(0)),
    customerNumber: z
      .string()
      .min(13, { message: '数字は13桁で入力してください' })
      .max(13, { message: '数字は13桁で入力してください' }),
    contractorName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    contractorNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー　 ]+$/, 'ひらがなで入力してください'),
    contractorPostalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    contractorPhone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    couponCode: z
      .string()
      .regex(/^[0-9,A-Z,a-z]+$/, '半角英数字で入力してください')
      .or(z.string().length(0)),
    aggree: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    }),
    covenant: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    })
  }
  const paymentIsCredit = {
    // unknownCustomerNumber: z.literal(false),
    payment: z.string().min(1, { message: '選択してください' }),
    lastName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    firstName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    lastNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    firstNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    postalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    pref: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    city: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    town: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    place: z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください')
      .or(z.string().length(0)),
    phone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    customerNumber: z
      .string()
      .min(13, { message: '数字は13桁で入力してください' })
      .max(13, { message: '数字は13桁で入力してください' }),
    paymentNumber: z
      .string()
      .min(4, { message: '必須入力です' })
      .regex(/^[0-9]+$/, '半角数字で入力してください'),
    couponCode: z
      .string()
      .regex(/^[0-9,A-Z,a-z]+$/, '半角英数字で入力してください')
      .or(z.string().length(0)),
    aggree: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    }),
    covenant: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    })
  }
  const paymentIsBank = {
    payment: z.string().min(1, { message: '選択してください' }),
    lastName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    firstName: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    lastNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    firstNameKana: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[ぁ-ゞー]+$/, 'ひらがなで入力してください'),
    postalCode: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[0-9]{3}-[0-9]{4}$/, '999-9999のフォーマットで入力してください'),
    pref: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    city: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    town: z
      .string()
      .min(1, { message: '必須入力です' })
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください'),
    place: z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$/, '全角で入力してください')
      .or(z.string().length(0)),
    phone: z
      .string()
      .min(12, { message: '数字は10桁または11桁で入力してください' })
      .max(13, { message: '数字は10桁または11桁で入力してください' })
      .regex(/^[0-9,-]+$/, '半角数字または半角ハイフンで入力してください'),
    customerNumber: z
      .string()
      .min(13, { message: '数字は13桁で入力してください' })
      .max(13, { message: '数字は13桁で入力してください' }),
    paymentNumber: z
      .string()
      .min(4, { message: '必須入力です' })
      .regex(/^[0-9]+$/, '半角数字で入力してください'),
    couponCode: z
      .string()
      .regex(/^[0-9,A-Z,a-z]+$/, '半角英数字で入力してください')
      .or(z.string().length(0)),
    aggree: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    }),
    covenant: z.boolean().refine((value) => value === true, {
      message: 'お申込にはチェックが必要です'
    })
  }
  const withoutKatene = {
    barthYear: z.string().min(1, { message: '選択してください' }),
    barthMonth: z.string().min(1, { message: '選択してください' }),
    gender: z.string().min(1, { message: '選択してください' }),
    gas: z.string().min(1, { message: '選択してください' })
  }
  const [schema, setSchema] = useState<any>(
    z.object(
      isEmpty(kateneId)
        ? { ...paymentIsCredit, ...withoutKatene }
        : paymentIsCredit
    )
  )

  useEffect(() => {
    // if (isNil(user)) {
    //   setHasError(true)
    //   setLoading(false)
    // }else{
    //   setHasError(false)
    // }
    if (!isNil(user?.sub) && !isNil(user?.email)) {
      const checkKateneId = async () => {
        const { sub, email: authMail } = user as User
        const token = await getAccessTokenSilently()
        const response = await httpRequest(
          'get',
          `https://${domainName}/v1/entry/is-katene-member/${token}/${authMail}`
        )
        if (isNil(response)) {
          setHasError(true)
          return undefined
        }
        const { data } = response
        setEmail(authMail as string)
        setKateneId(data.memberId ?? '')
        setTcId(sub as string)
        setLoading(false)
      }
      checkKateneId()
    }
  }, [user])
  useEffect(() => {
    const schemaObject = unknownCustomerNumber
      ? customerNumberIsUnknown
      : payment === 'credit'
      ? paymentIsCredit
      : payment === 'transfer'
      ? paymentIsBank
      : paymentIsUnknown
    setSchema(
      z.object(
        isEmpty(kateneId) ? { ...schemaObject, ...withoutKatene } : schemaObject
      )
    )
  }, [payment, unknownCustomerNumber])

  const useFormMethods = useForm({
    resolver: zodResolver(schema)
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    control
  } = useFormMethods

  // const onSubmit: SubmitHandler<any> = async (_data) => {
  //   // setActiveStep((prevActiveStep) => prevActiveStep + 1)
  //   log.debug('run')
  //   await sendRequestData(formData).catch(log.error)
  // }

  const handleNext = (_data: any) => {
    if (activeStep === ActiveSteps.form) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1)
    }
    if (activeStep === ActiveSteps.credit) {
      setLoading(true)
      httpRequest(
        'get',
        `https://${domainName}/v1/entry/is-credit-regist/${memberId}`
      )
        .then((response) => {
          setLoading(false)
          if (isNil(response) || response.status !== 200) {
            setAlertStatus('credit-internal-error')
          } else if (response.data.success === false) {
            const { errorReason } = response.data as CreditCheck
            if (errorReason === CreditCheckError.badRequest) {
              setAlertStatus('credit-bad-request')
            } else {
              setAlertStatus('credit-internal-error')
            }
          } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
          }
        })
        .catch((error) => {
          setLoading(false)
          log.error(error)
          setAlertStatus('credit-internal-error')
        })
    }
    if (activeStep === ActiveSteps.confirm) {
      sendRequestData(formData).then((result) => {
        result
          ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
          : setAlertStatus('confirm')
      })
    }
  }
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }
  const handleCorrect = () => {
    setActiveStep(0)
  }
  const handleAlertClose = () => {
    setAlertStatus(undefined)
  }
  const formData = {
    memberId,
    lastName,
    firstName,
    lastNameKana,
    firstNameKana,
    postalCode,
    pref,
    city,
    town,
    place,
    phone,
    email,
    barthYear,
    barthMonth,
    gender,
    gas,
    kateneMailMagazine,
    tokutokuMailMagazine,
    customerNumber,
    unknownCustomerNumber,
    payment,
    paymentNumber,
    contractorName,
    contractorNameKana,
    contractorPostalCode,
    contractorPhone,
    agree,
    covenant,
    couponCode,
    kateneId,
    tcId
  }
  const formsProps: FormsProps = {
    register,
    setters: {
      setMemberId,
      setLastName,
      setFirstName,
      setLastNameKana,
      setFirstNameKana,
      setPostalCode,
      setPref,
      setCity,
      setTown,
      setPlace,
      setPhone,
      setEmail,
      setBarthYear,
      setBarthMonth,
      setGender,
      setGas,
      setKateneMailMagazine,
      setTokutokuMailMagazine,
      setCustomerNumber,
      setUnknownCustomerNumber,
      setPayment,
      setPaymentNumber,
      setContractorName,
      setContractorNameKana,
      setContractorPostalCode,
      setContractorPhone,
      setAgree,
      setCovenant,
      setCouponCode,
      setKateneId
    },
    formData,
    errors,
    control
  }
  const contentArray = [
    <RequestForm {...formsProps} />,
    <RegistCreditCard {...formsProps} />,
    <RequestConfirm {...formsProps} />
  ]

  //   if (isEmpty(memberId)) {
  //     createMemberId()
  //       .then((newId) => {
  //         if (!isNil(newId)) setMemberId(newId)
  //       })
  //       .catch(log.error)
  //   }
  return loading ? (
    <Loading />
  ) : hasError ? (
    <ServerError />
  ) : (
    <Grid2 container>
      <Grid2 size={{ sm: 2 }} />
      <Grid2 size={{ lg: 8, sm: 8 }} spacing={10}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length ? (
          <Box>{lastContent}</Box>
        ) : (
          <Box>
            <FormProvider {...useFormMethods}>
              <Typography>
                {getStepContent(activeStep, contentArray)}
              </Typography>
            </FormProvider>
            <Box
              display={'flex'}
              justifyContent={'space-around'}
              paddingTop={3}>
              <Button
                variant="outlined"
                sx={
                  activeStep === 2
                    ? { display: 'block', width: '50%' }
                    : { display: 'none', width: '80%' }
                }
                onClick={handleCorrect}>
                {buttonNames.correct}
              </Button>
            </Box>
            <Box
              display={'flex'}
              justifyContent={'space-around'}
              paddingTop={3}>
              <Box justifyContent={'start'}>
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  onClick={handleBack}>
                  {buttonNames.back}
                </Button>
              </Box>
              <Box justifyContent={'end'}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={
                    activeStep === ActiveSteps.form
                      ? handleSubmit(handleNext)
                      : handleNext
                  }>
                  {activeStep === steps.length - 1
                    ? buttonNames.submit
                    : buttonNames.next}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Grid2>
      <Snackbar
        open={!isEmpty(alertStatus)}
        autoHideDuration={5000}
        onClose={handleAlertClose}>
        <Alert severity="error">
          <AlertTitle>
            {!isEmpty(alertStatus)
              ? alertPropaties[alertStatus as keyof typeof alertPropaties][
                  'alertTitle'
                ]
              : ''}
          </AlertTitle>
          {!isEmpty(alertStatus)
            ? alertPropaties[alertStatus as keyof typeof alertPropaties][
                'alertMessage'
              ]
            : ''}
        </Alert>
      </Snackbar>
    </Grid2>
  )
}

export default FormProgress
